import { IAuthenticationRepository } from '../domain/IAuthenticationRepository'

export class RedirectionToLoginPage {
  constructor(private readonly authenticationRepository: IAuthenticationRepository) {}

  async execute(params): Promise<void> {
    return this.authenticationRepository.loginWithRedirect(params)
  }
}
